import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "banner-scene" }
const _hoisted_2 = { class: "banner-wrap" }
const _hoisted_3 = { class: "banner-box" }
const _hoisted_4 = ["src"]
const _hoisted_5 = ["src"]

import { ref, reactive, onMounted, onUnmounted, watch } from 'vue'

export default /*@__PURE__*/_defineComponent({
  __name: 'BannerView',
  props: {
  bannerData: {
    default: null,
    type: Object
  }
},
  setup(__props) {

const props = __props
const showIndexs: any = ref([2, 3, 0, 1, 2, 3, 0])
const activeIndex: any = ref(3)
const showList: any = ref([])
let timer: any = null;
let timer2: any = null;
let clicks: any = false;
const active_r_i = ref(3)

const prevEvent = () => {
  if (clicks) return;
  clicks = true;
  (document.querySelector('.banner-box') as any).style.transition = 'all .5s';
  (document.querySelector('.banner-box') as any).style.left = '-0rem';
  (document.querySelectorAll('.banner-box>div') as any).forEach((ele: any) => {
    ele.style.transition = 'all ease-in-out .5s'
  });
  (document.querySelectorAll('.view-box.active>img') as any).forEach((ele: any, i: number) => {
    if (i != 0) {
      ele.style.transition = 'none'
      ele.style.left = props.bannerData[active_r_i.value].imgs[i].size[0] - 100 + 'rem'
      ele.style.opacity = 0
    }
  });
  if (active_r_i.value != 0) {
    active_r_i.value -= 1;
  } else {
    active_r_i.value = props.bannerData.length - 1
  }
  activeIndex.value -= 1;
}

const nextEvent = () => {
  if (clicks) return;
  clicks = true;
  (document.querySelector('.banner-box') as any).style.transition = 'all .5s';
  (document.querySelector('.banner-box') as any).style.left = '-560rem';
  (document.querySelectorAll('.banner-box>div') as any).forEach((ele: any) => {
    ele.style.transition = 'all ease-in-out .5s'
  });
  (document.querySelectorAll('.view-box.active>img') as any).forEach((ele: any, i: number) => {
    if (i != 0) {
      ele.style.transition = 'none'
      ele.style.left = props.bannerData[active_r_i.value].imgs[i].size[0] - 100 + 'rem'
      ele.style.opacity = 0
    }
  });

  if (active_r_i.value != props.bannerData.length - 1) {
    active_r_i.value += 1;
  } else {
    active_r_i.value = 0
  }
  activeIndex.value += 1;
}

onMounted(() => {
  showList.value = showIndexs.value.map((k: number) => props.bannerData[k]);
  (document.querySelectorAll('.view-box') as any).forEach((ele: any, index: number) => {
    const imgs = ele.querySelectorAll('img')
    imgs.forEach((e: any, i: number) => {
      if (i != 0) {
        e.style.left = props.bannerData[index].imgs[i].size[0] - 100 + 'rem'
        e.style.opacity = 0
      }
    });
  });
  setTimeout(() => {
    (document.querySelectorAll('.view-box.active>img') as any).forEach((ele: any, i: number) => {
      if (i != 0) {
        ele.style.transition = 'all ease-in-out .5s'
        ele.style.left = props.bannerData[active_r_i.value].imgs[i].size[0] + 'rem'
        ele.style.opacity = 1
      }
    });
  })
  clearInterval(timer)
  timer = setInterval(() => {
    nextEvent()
  }, 3000)
})

onUnmounted(() => {
  clearInterval(timer)
  clearInterval(timer2)
})

watch(active_r_i, (newState) => {
  clearInterval(timer)
  showIndexs.value = showIndexs.value.map((v: number, i: number) => {
    if (i < 3) {
      if ((newState - (3 - i)) >= 0) {
        return newState - (3 - i)
      } else {
        return (props.bannerData.length + newState) - (3 - i)
      }
    }
    if (i == 3) return newState
    if (i > 3) {
      if ((newState < props.bannerData.length - 3) || (newState + (i - 3) < props.bannerData.length)) {
        return newState + (i - 3)
      } else {
        return newState + (i - 3) - props.bannerData.length
      }
    }
  });
  clearTimeout(timer2)

  timer2 = setTimeout(() => {
    (document.querySelector('.banner-box') as any).style.transition = 'none';
    (document.querySelector('.view-box img') as any).style.transition = 'none';
    (document.querySelector('.banner-box') as any).style.left = '-280rem';
    (document.querySelectorAll('.banner-box>div') as any).forEach((ele: any) => {
      ele.style.transition = 'none'
    });
    (document.querySelectorAll('.view-box.active>img') as any).forEach((ele: any, i: number) => {
      if (i != 0) {
        ele.style.transition = 'all ease-in-out .5s'
        ele.style.left = props.bannerData[active_r_i.value].imgs[i].size[0] + 'rem'
        ele.style.opacity = 1
      }
    });
    showList.value = showIndexs.value.map((k: number) => props.bannerData[k]);
    activeIndex.value = 3
    clicks = false
    clearInterval(timer)
    timer = setInterval(() => {
      nextEvent()
    }, 3000)
  }, 500)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "prev",
      onClick: prevEvent
    }),
    _createElementVNode("div", {
      class: "next",
      onClick: nextEvent
    }),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(showList.value, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            class: _normalizeClass((activeIndex.value == index) ? 'active' : '')
          }, [
            _createElementVNode("div", null, _toDisplayString(item.title), 1)
          ], 2))
        }), 128))
      ]),
      _createElementVNode("div", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.bannerData, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: _normalizeClass([active_r_i.value == item.type ? 'active' : '', "view-box"]),
            key: index
          }, [
            (item.type === 3)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "web-bg",
                  style: _normalizeStyle({ left: item.imgs[0].size[0] + 'rem', top: item.imgs[0].size[1] + 'rem', opacity: active_r_i.value == item.type ? 1 : 0 })
                }, null, 4))
              : _createCommentVNode("", true),
            _createElementVNode("img", {
              class: _normalizeClass(item.type === 3 ? 'web-gif' : item.imgs[0].class),
              src: item.imgs[0].url,
              style: _normalizeStyle({ left: item.imgs[0].size[0] + 'rem', top: item.imgs[0].size[1] + 'rem', opacity: active_r_i.value == item.type ? 1 : 0 })
            }, null, 14, _hoisted_4),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.imgs.slice(1), (e, i) => {
              return (_openBlock(), _createElementBlock("img", {
                class: _normalizeClass(e.class),
                src: e.url,
                style: _normalizeStyle({ top: e.size[1] + 'rem' }),
                key: i
              }, null, 14, _hoisted_5))
            }), 128))
          ], 2))
        }), 128))
      ])
    ])
  ]))
}
}

})